import React from "react";

export const useTopOfForm = () => {
  React.useEffect(() => {
    window.scroll(0, 0);
  }, []);
};
